import { Note } from '@/@types/note';
import { Modal } from '@/components/common';
import { NoteFormData } from '@/modules/notes/schemas/note-form-schema';
import { Close } from '@mui/icons-material';
import { DialogTitle, IconButton, LinearProgress } from '@mui/material';

import { NoteForm, NoteFormPlaceholder } from '../NoteForm';

type NoteModalProps = {
  note?: Note;
  isOpen: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (data: NoteFormData) => void;
};

export function NoteModal({
  note,
  isOpen,
  isLoading,
  isSubmitting,
  onClose,
  onSubmit,
}: NoteModalProps) {
  return (
    <Modal open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ p: 2 }}>
        {note ? 'Alterar Observação' : 'Nova Observação'}
        <IconButton
          aria-label="Fechar"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 12,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      {isSubmitting ? <LinearProgress /> : null}
      {isLoading ? (
        <NoteFormPlaceholder />
      ) : (
        <NoteForm
          note={note}
          isLoading={isSubmitting}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      )}
    </Modal>
  );
}
